import React, { useState } from "react";
import ketanImg from "../../assets/About us/Desktop/DrImage.png";
import PallaviImg from "../../assets/About us/Desktop/PallaviImage.png";
import AdvaitImg from "../../assets/About us/Desktop/Advaitimage.png";

const MeetOurTeam = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <section className="py-12 md:px-[75px] px-6">
        <div className="">
          {/* Heading */}
          <h2
            className="
              font-garamond-subheading font-normal text-[32px] leading-[110%]
              md:text-[80px] md:leading-[100%] text-[#2C3075] mb-8
            "
          >
            Meet the team
          </h2>

          {/* Content */}
          <div className="grid md:grid-cols-2 gap-8 items-start">
            {/* Left column - Image */}
            <div className="flex justify-center md:justify-start">
              <img
                src={ketanImg}
                alt="Dr. Ketan Vaidya"
                className="
                  w-[342px] h-[406.73px] md:w-[417px] md:h-[619px]
                  rounded-t-[208.5px] object-cover
                "
              />
            </div>

            {/* Right column - Details */}
            <div>
              <h3
                className="
                  font-generalsans-headfounder  text-[#2C3075] mb-2
                "
              >
                Dr. Ketan Vaidya
              </h3>
              <p
                className="
                  font-generalsans-headfounde-description text-[#A1A1A1] 
                   md:leading-[150%]
                "
              >
                DPM (Psychiatry) and MBBS from University of Pune
              </p>
              <p
                className="
                  font-generalsans-headfounde-description text-[#A1A1A1] text-[14px]
                  md:text-[24px] md:leading-[150%]
                "
              >
                19 years of experience as a psychiatrist
              </p>
              <p
                className="
                  font-generalsans-headfounde-description text-[#A1A1A1] text-[14px]
                  md:text-[24px] md:leading-[150%] mb-[24px]
                "
              >
                Ex-member of Regional Psychiatric Hospital, Pune Civil Hospital
              </p>
              <hr className="border-[#2C3075] mb-4" />

              <p
                className="
                  font-generalsans-description font-normal text-[14px] leading-[130%] text-[#2C3075] mb-4
                  md:text-[20px] md:leading-[130%]
                "
              >
                Dr. Ketan Vaidya is a renowned psychiatrist in Mumbai with over
                19 years of experience in treating various mental health
                conditions. He specializes in treatment of -
              </p>

              <div
                className="
                  font-generalsans-description font-normal text-[14px] leading-[130%] text-[#2C3075] mb-3
                  md:text-[20px] md:leading-[130%]
                "
              >
                <ul className="">
                  <p>
                    - Mental Health Conditions: Depression, anxiety, bipolar
                    disorder, schizophrenia, sleep disorders, Dementia.
                  </p>
                  <p>
                    - Addiction Treatment: Deaddiction counseling,
                    rehabilitation center
                  </p>
                  <p>- Counseling Services: CBT, REBT ,psychotherapy</p>
                  <br />
                </ul>
              </div>
              <div
                className="
                  font-generalsans-description font-normal text-[14px] leading-[130%] text-[#2C3075] mb-4
                  md:text-[20px] md:leading-[130%]
                "
              >
                <ul className="">
                  <p>Education and Experience:</p>
                  <p>- DPM (Psychiatry) and MBBS from University of Pune</p>
                  <p>- 19+ years of experience as a psychiatrist</p>
                  <p>- Ex-member of Regional Psychiatric Hospital, Pune Civil Hospital</p>
                  <p>-Currently owns a clinic named Happy Solutions clinic in Gokuldham , Goregaon East since last 13 years .</p>
                  <br />
                </ul>
              </div>

              {/* Read More Toggle */}
              {!showMore && (
                <button
                  onClick={() => setShowMore(true)}
                  className="text-[#2C3075] font-generalsans-description  underline font-medium"
                >
                  Read More
                </button>
              )}

              {showMore && (
                <div
                  className="
                    mt-4 font-generalsans-description font-normal text-[14px] leading-[130%] text-[#2C3075] space-y-3
                    md:text-[20px] md:leading-[130%]
                  "
                >
                  <p>His aim of starting a rehab center is:</p>
                  <ol className="list-decimal pl-5 space-y-2">
                    <li>
                      Providing Supportive Environment: Creating a safe and
                      supportive space for individuals to recover from addiction
                      or mental health issues.
                    </li>
                    <li>
                      Holistic Recovery: Offering comprehensive treatment
                      programs that address physical, emotional, and
                      psychological aspects of addiction or mental health.
                    </li>
                    <li>
                      Empowering Individuals: Helping individuals develop coping
                      skills, self-awareness, and confidence to manage their
                      condition and achieve long-term recovery.
                    </li>
                    <li>
                      Reducing Relapse Rates: Providing evidence-based treatment
                      and support to minimize the risk of relapse and promote
                      sustained recovery.
                    </li>
                    <li>
                      Improving Quality of Life: Enhancing the overall
                      well-being and quality of life for individuals and their
                      families affected by addiction or mental health issues.
                    </li>
                    <li>
                      Raising Awareness: Educating the community about
                      addiction, mental health, and the importance of seeking
                      help.
                    </li>
                    <li>
                      Fostering Community: Building a supportive community of
                      peers and professionals to promote connection,
                      understanding, and growth.
                    </li>
                  </ol>

                  <button
                    onClick={() => setShowMore(false)}
                    className="text-[#2C3075] underline font-medium mt-4 block"
                  >
                    Show Less
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Other Doctors */}
      <section className="py-12 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Top Row */}
          <div className="grid md:grid-cols-2 gap-8 items-start text-center md:text-left">
            <div className="flex flex-col items-center">
              <img
                src={PallaviImg}
                alt="Dr. Pallavi Vaidya"
                className="
                  w-[342px] h-[406.73px] md:w-[417px] md:h-[506px]
                  rounded-t-[208.5px] object-cover
                "
              />
              <h3
                className="
                  font-generalsans-headfounder font-normal text-[32px] leading-[110%] text-[#2C3075] mt-4
                  md:text-[56px] md:leading-[110%]
                "
              >
                Dr. Pallavi Vaidya
              </h3>
              <p
                className="
                  font-generalsans-description content-center font-normal text-[14px] leading-[150%] text-[#A1A1A1] max-w-sm
                  md:text-[24px] md:leading-[150%] text-center
                "
              >
                A renowned consultant Radiologist in Mumbai with experience of
                13+ years
              </p>
            </div>

            {/* Advait */}
            <div className="flex flex-col items-center">
              <img
                src={AdvaitImg}
                alt="Dr. Advait Rasal"
                className="
                  w-[342px] h-[406.73px] md:w-[417px] md:h-[506px]
                  rounded-t-[208.5px] object-cover
                "
              />
              <h3
                className="
                  font-generalsans-headfounder font-normal text-[32px] leading-[110%] text-[#2C3075] mt-4
                  md:text-[56px] md:leading-[110%]
                "
              >
                Dr. Advait Rasal
              </h3>
              <p
                className="
                  font-generalsans-description font-normal text-[14px] leading-[150%] text-[#A1A1A1] max-w-sm
                  md:text-[24px] md:leading-[150%] text-center
                "
              >
                General Physician with experience of 7+ years
              </p>
            </div>
          </div>

          {/* Common description */}
          <div
            className="
              mt-8 text-center text-[#2C3075] max-w-6xl mx-auto
              font-garamond-discription font-normal
              
            "
          >
            <p className="md:py-[80px]">
              Our team is also supported by skilled professionals including
              psychologists, physiotherapists, occupational therapists,
              psychiatric social workers, and dedicated instructors in yoga,
              music, and arts, all working together to provide holistic care and
              recovery.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default MeetOurTeam;
